<script>
  import { ignore } from '../../../Common/tools';
  import { External, M } from '../../../external';
  import { onMount } from 'svelte';

  export let data,
    valid,
    onChange = ignore;

  let result = {
    commentId: null,
    pollOptionId: null
  };

  const commentPostOptions = {
    isLoading: false,
    data: [],
    fetch: async (commentId) => {
      const BASE_URL = `https://${External.serviceApiDomain}/comment/admin`;
      const url = `${BASE_URL}/${commentId}/detail`;
      commentPostOptions.isLoading = true;
      commentPostOptions.data = [];
      const response = await fetch(url, {
        method: 'GET',
        cache: 'no-cache',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'X-Website-Hash': External.WebPlatform.hash,
          'X-Admin-Hash': External.Website.hash
        }
      });
      commentPostOptions.isLoading = false;

      if (!response.ok) {
        return;
      }

      const post = await response.json();
      if (!post || !post.attachments || !post.attachments.poll) {
        External.Tools.showError(M.NO_POLL_OPTIONS);
        return;
      }

      commentPostOptions.data = post.attachments.poll.options || [];
    }
  };

  const onCommentIdChanged = () => {
    if (!result.commentId) {
      return;
    }

    commentPostOptions.fetch(result.commentId);
  };

  const onResultChange = () => {
    if (result.commentId && result.pollOptionId) {
      data.settings = [];
      data.settings.push({
        key: '0',
        value: JSON.stringify(result)
      });

      const option = commentPostOptions.data.find((iter) => iter.id === result.pollOptionId);
      data.name = `On ${option.name}`;
      valid = true;
      onChange();
    } else {
      valid = false;
    }
  };

  onMount(() => {
    if (!data.settings) {
      data.settings = [];
    }
    if (data.settings.length > 0) {
      result = JSON.parse(data.settings[0].value);
    }

    if (result.commentId) {
      commentPostOptions.fetch(result.commentId);
    }
  });
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">{M.POLL_OPTION_TRIGGER_TITLE}</h4>
  <div class="popup-input-wrapper f-left mt-25">
    <div class="info">
      <h5>{M.ENTER_POST_ID}</h5>
    </div>
    <input type="text" bind:value={result.commentId} on:change={onCommentIdChanged} />
  </div>

  {#if result.commentId}
    <div class="popup-input-wrapper f-left">
      <div class="info">
        <h5>{M.SELECT_POLL_OPTION}</h5>
      </div>
      {#if commentPostOptions.isLoading}
        <div class="col20 f-left t-center mt-5">
          <i class="fa fa-circle-o-notch fa-spin"></i>
        </div>
      {:else if commentPostOptions.data.length === 0}
        <div class="col20 f-left t-center no-data-box white-bg">
          <span>{M.NO_POLL_OPTIONS}</span>
        </div>
      {:else}
        <select class="page-select" bind:value={result.pollOptionId} on:change={onResultChange}>
          <option value="0" disabled>{M.PLEASE_SELECT}</option>
          {#each commentPostOptions.data as option}
            <option value={option.id}>{option.name}</option>
          {/each}
        </select>
      {/if}
    </div>
  {/if}
</div>
